// Actions
export const setBoletador = ({ commit }, payload) => {
  commit('SET_BOLETADOR', payload)
}
export const addBoletador = ({ commit }, payload) => {
  commit('ADD_BOLETADOR', payload)
}
export const setBoletadorLoading = ({ commit }, payload) => {
  commit('SET_BOLETADOR_LOADING', payload)
}

export const setProdutos = ({ commit }, payload) => {
  commit('SET_PRODUTOS', payload)
}
export const addProdutos = ({ commit }, payload) => {
  commit('ADD_PRODUTOS', payload)
}
export const setProdutosLoading = ({ commit }, payload) => {
  commit('SET_PRODUTOS_LOADING', payload)
}

export const setClients = ({ commit }, payload) => {
  commit('SET_CLIENTS', payload)
}
export const addClients = ({ commit }, payload) => {
  commit('ADD_CLIENTS', payload)
}
export const setClientsLoading = ({ commit }, payload) => {
  commit('SET_CLIENTS_LOADING', payload)
}

